import { apiRoutes } from '../config/api'
import type { SongToneAnalysis, ToneAnalysisRequest } from '../models/toneAnalysis'
import { post } from './httpClient'

export function analyzeTone(request: ToneAnalysisRequest, signal?: AbortSignal) {
  return post<ToneAnalysisRequest, SongToneAnalysis>(apiRoutes.toneAnalysis, request, signal)
}
